export function short_date(value) {
  if (!value) return ''

  value =  value ? value.replace(/ \d{2}:\d{2}:\d{2} GMT/, '') : '';
  value =  value ? value.replace(/ \d{2}:\d{2}/, '') : '';
  return value
}

export function short_time(value) {
  if (!value) return ''

  value =  value ? value.replace(/\..*/, '') : '';
  return value
}
export function format_pct(value) {
  if (!value) {return 0}

  value =  value ? (value*100).toFixed(2) : '';
  return value
}
export function get_sc_val(value) {
   let sc_codes = {
        '01':'NULA',
        '02':'ATIVA',
        '03':'SUSPENSA',
        '04': 'INAPTA',
        '08': 'BAIXADA'
    }
  return sc_codes[value]
}
export function get_natjuridica_val(value) {
   let sc_codes = {
        '1015' : 'Órgão Público do Poder Executivo Federal',
        '1023' : 'Órgão Público do Poder Executivo Estadual ou do Distrito Federal',
        '1031' : 'Órgão Público do Poder Executivo Municipal',
        '1040' : 'Órgão Público do Poder Legislativo Federal',
        '1058' : 'Órgão Público do Poder Legislativo Estadual ou do Distrito Federal',
        '1066' : 'Órgão Público do Poder Legislativo Municipal',
        '1074' : 'Órgão Público do Poder Judiciário Federal',
        '1082' : 'Órgão Público do Poder Judiciário Estadual',
        '1104' : 'Autarquia Federal',
        '1112' : 'Autarquia Estadual ou do Distrito Federal',
        '1120' : 'Autarquia Municipal',
        '1139' : 'Fundação Pública de Direito Público Federal',
        '1147' : 'Fundação Pública de Direito Público Estadual ou do Distrito Federal',
        '1155' : 'Fundação Pública de Direito Público Municipal',
        '1163' : 'Órgão Público Autônomo Federal',
        '1171' : 'Órgão Público Autônomo Estadual ou do Distrito Federal',
        '1180' : 'Órgão Público Autônomo Municipal',
        '1198' : 'Comissão Polinacional',
        '1210' : 'Consórcio Público de Direito Público (Associação Pública)',
        '1228' : 'Consórcio Público de Direito Privado',
        '1236' : 'Estado ou Distrito Federal',
        '1244' : 'Município',
        '1252' : 'Fundação Pública de Direito Privado Federal',
        '1260' : 'Fundação Pública de Direito Privado Estadual ou do Distrito Federal',
        '1279' : 'Fundação Pública de Direito Privado Municipal',
        '1287' : 'Fundo Público da Administração Indireta Federal',
        '1295' : 'Fundo Público da Administração Indireta Estadual ou do Distrito Federal',
        '1309' : 'Fundo Público da Administração Indireta Municipal',
        '1317' : 'Fundo Público da Administração Direta Federal',
        '1325' : 'Fundo Público da Administração Direta Estadual ou do Distrito Federal',
        '1333' : 'Fundo Público da Administração Direta Municipal',
        '1341' : 'União',
        '2011' : 'Empresa Pública',
        '2038' : 'Sociedade de Economia Mista',
        '2046' : 'Sociedade Anônima Aberta',
        '2054' : 'Sociedade Anônima Fechada',
        '2062' : 'Sociedade Empresária Limitada',
        '2070' : 'Sociedade Empresária em Nome Coletivo',
        '2089' : 'Sociedade Empresária em Comandita Simples',
        '2097' : 'Sociedade Empresária em Comandita por Ações',
        '2127' : 'Sociedade em Conta de Participação',
        '2135' : 'Empresário (Individual)',
        '2143' : 'Cooperativa',
        '2151' : 'Consórcio de Sociedades',
        '2160' : 'Grupo de Sociedades',
        '2178' : 'Estabelecimento, no Brasil, de Sociedade Estrangeira',
        '2194' : 'Estabelecimento, no Brasil, de Empresa Binacional Argentino-Brasileira',
        '2216' : 'Empresa Domiciliada no Exterior',
        '2224' : 'Clube/Fundo de Investimento',
        '2232' : 'Sociedade Simples Pura',
        '2240' : 'Sociedade Simples Limitada',
        '2259' : 'Sociedade Simples em Nome Coletivo',
        '2267' : 'Sociedade Simples em Comandita Simples',
        '2275' : 'Empresa Binacional',
        '2283' : 'Consórcio de Empregadores',
        '2291' : 'Consórcio Simples',
        '2305' : 'Empresa Individual de Responsabilidade Limitada (de Natureza Empresária)',
        '2313' : 'Empresa Individual de Responsabilidade Limitada (de Natureza Simples)',
        '2321' : 'Sociedade Unipessoal de Advogados',
        '2330' : 'Cooperativas de Consumo',
        '3034' : 'Serviço Notarial e Registral (Cartório)',
        '3069' : 'Fundação Privada',
        '3077' : 'Serviço Social Autônomo',
        '3085' : 'Condomínio Edilício',
        '3107' : 'Comissão de Conciliação Prévia',
        '3115' : 'Entidade de Mediação e Arbitragem',
        '3131' : 'Entidade Sindical',
        '3204' : 'Estabelecimento, no Brasil, de Fundação ou Associação Estrangeiras',
        '3212' : 'Fundação ou Associação Domiciliada no Exterior',
        '3220' : 'Organização Religiosa',
        '3239' : 'Comunidade Indígena',
        '3247' : 'Fundo Privado',
        '3255' : 'Órgão de Direção Nacional de Partido Político',
        '3263' : 'Órgão de Direção Regional de Partido Político',
        '3271' : 'Órgão de Direção Local de Partido Político',
        '3280' : 'Comitê Financeiro de Partido Político',
        '3298' : 'Frente Plebiscitária ou Referendária',
        '3301' : 'Organização Social (OS)',
        '3310' : 'Demais Condomínios',
        '3999' : 'Associação Privada',
        '4014' : 'Empresa Individual Imobiliária',
        '4022' : 'Segurado Especial',
        '4081' : 'Contribuinte individual',
        '4090' : 'Candidato a Cargo Político Eletivo',
        '4111' : 'Leiloeiro',
        '4120' : 'Produtor Rural (Pessoa Física)',
        '5010' : 'Organização Internacional',
        '5029' : 'Representação Diplomática Estrangeira',
        '5037' : 'Outras Instituições Extraterritoriais',
    }
  return sc_codes[value]
}
export function get_qualif_val(value) {
   let qc_codes = {
        '05': 'ADMINISTRADOR',
        '08': 'CONSELHEIRO DE ADMINISTRAÇÃO',
        '09' : ' CURADOR',
        '5': 'ADMINISTRADOR',
        '8': 'CONSELHEIRO DE ADMINISTRAÇÃO',
        '9' : ' CURADOR',
        '10' : ' Diretor',
        '11': 'INTERVENTOR',
        '12': 'INVENTARIANTE',
        '13': 'LIQUIDANTE',
        '14' : 'MÃE',
        '15' : 'PAI',
        '16': 'PRESIDENTE',
        '17': 'PROCURADOR',
        '18': 'SECRETÁRIO',
        '19': 'SÍNDICO (CONDOMÍNIO)',
        '20' : ' SOCIEDADE CONSORCIADA',
        '21' : ' SOCIEDADE FILIADA',
        '22': 'SÓCIO/ADMINISTRADOR',
        '23' : ' SÓCIO CAPITALISTA',
        '24': 'SÓCIO COMANDITADO',
        '25' : ' SÓCIO COMANDITÁRIO',
        '26' : ' SÓCIO DE INDÚSTRIA',
        '28' : ' SÓCIO GERENTE',
        '29' : ' SÓCIO OU ACIONISTA INCAPAZ OU RELATIVAMENTE INCAPAZ (EXCETO MENOR)',
        '30' : ' SÓCIO OU ACIONISTA MENOR (ASSISTIDO/REPRESENTADO)',
        '31': 'SÓCIO OSTENSIVO',
        '32': 'TABELIÃO',
        '33': 'TESOUREIRO',
        '34': 'TITULAR DE EMPRESA INDIVIDUAL IMOBILIÁRIA',
        '35' : ' TUTOR',
        '37' : ' SÓCIO PESSOA JURÍDICA DOMICILIADO NO EXTERIOR',
        '38' : ' SÓCIO PESSOA FÍSICA RESIDENTE OU DOMICILIADO NO EXTERIOR',
        '39': 'DIPLOMATA',
        '40': 'CÔNSUL',
        '41': 'REPRESENTANTE DE ORGANIZAÇÃO INTERNACIONAL',
        '42': 'OFICIAL DE REGISTRO',
        '43': 'RESPONSÁVEL',
        '46': 'MINISTRO DE ESTADO DAS RELAÇÕES EXTERIORES',
        '47' : ' SÓCIO PESSOA FÍSICA RESIDENTE NO BRASIL',
        '48' : ' SÓCIO PESSOA JURÍDICA DOMICILIADO NO BRASIL',
        '49': 'SÓCIO-ADMINISTRADOR',
        '50': 'EMPRESÁRIO',
        '51': 'CANDIDATO A CARGO POLÍTICO ELETIVO',
        '52' : ' SÓCIO COM CAPITAL',
        '53' : ' SÓCIO SEM CAPITAL',
        '54': 'FUNDADOR',
        '59': 'PRODUTOR RURAL',
        '60': 'CÔNSUL HONORÁRIO',
        '61': 'RESPONSÁVEL INDÍGENA',
        '62': 'REPRESENTANTE DA INSTITUIÇÃO EXTRATERRITORIAL',
        '64': 'ADMINISTRADOR JUDICIAL',
        '65': 'TITULAR PESSOA FÍSICA RESIDENTE OU DOMICILIADO NO BRASIL',
        '77': 'VICE-PRESIDENTE',
    }
  return qc_codes[value]
}

export function format_cnpj(value) {
  if (!value) return ''
  if (typeof value === 'object') {
    return 'Invalid'
  }

  const cnpj = value.replace(/\D/g, '')
  if (value.length === 8) {
    return cnpj.replace(/^(\d{2})(\d{3})(\d{3})$/, "$1.$2.$3");
  } else if (value.length === 14) {
    return cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, "$1.$2.$3/$4-$5");
  }

  return cnpj
}
export function format_cpf(value) {
  if (!value) return ''
  if (typeof value === 'object') {
    return 'Invalid'
  }
  if(value.length === 14 && value.substring(0,3) === '000'){
    value = value.substring(3)
  }
  const cpf = value.match(/.{1,3}/g)
  let finalstring = ''
  if (value.length === 11) {
    cpf.forEach((row, index) => finalstring += index === 0 ? row : row.length === 3 ? '.' + row : '-' + row)
    return finalstring
  }

  return cpf
}
export function cnpj_banch(value) {
  const cnpj = value.replace(/\D/g, '')

  if (value.length === 14) {
    return cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, "$4-$5");
  }
  // else
  return 'invalid cnpj14'
}

export function format_cep(value) {
  // this is not rigorous
  value = value.toString()

  if (value.length > 8) {
    value = value.substr(1)
  }
  return value
}

export function format_money(value) {
  if (!value) return ''
  // console.log('format money', value)
  value = value/100

  return new Intl.NumberFormat('pt-BR',
    {currency: 'BRL', style: 'currency'})
    .format(value)
}

export function format_money_short(value) {
  if (!value) return ''
  // console.log('format money', value)

  const newValue = new Intl.NumberFormat('pt-BR',
    {currency: 'BRL', style: 'currency'})
    .format(value);

  return newValue
}

export function format_money_compact(value) {
  if (!value) {value = 0}

  return new Intl.NumberFormat('pt-BR',
    {
      currency: 'BRL',
      style: 'currency',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })
    .format(value)
}

export function money_abbrev(num, decimals){
  if (num === null) {
    return null;
  }
  if (num === 0) {
    return '0';
  }
  decimals = (!decimals || decimals < 0) ? 0 : decimals; // number of decimal places to show
  let b = (num).toPrecision(2).split("e"), // get power
    k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 3), // floor at decimals, ceiling at trillions
    c = k < 1 ? num.toFixed(0 + decimals) : (num / Math.pow(10, k * 3)).toFixed(1 + decimals), // divide by power
    d = c < 0 ? c : Math.abs(c), // enforce -0 is 0
    e = d + ['', 'K', 'M', 'B', 'T'][k]; // append power
  return e;
}

export function url_encode(url) {
  return encodeURIComponent(url)
}

export function clean_cnpj(full_cnpj) {
  if (!full_cnpj) return null

  const clean_cnpj = full_cnpj.replace(/\D/g, '').substr(0, 8)

  return clean_cnpj

}

export function getAge(dateString) {
  if (!dateString) return ''
  let today = Date.now() / 1000;
  let date = new Date(dateString).getTime() / 1000;
  let diff = today - date
  const SEC_DAY = 24 * 3600
  const SEC_MONTH = SEC_DAY * 30
  const SEC_YEAR = SEC_DAY * 365

  let years = Math.floor(diff / SEC_YEAR);
  diff -= years * SEC_YEAR
  let months = Math.floor(diff / SEC_MONTH)

  let ageArr = []
  if (years) {
    ageArr.push(years + ' ano' + (years === 1 ? '' : 's'))
  }
  if (months) {
    ageArr.push(months === 1 ? months + ' mês' : months + ' meses' )
  }

  let age = ageArr.length ? ageArr.join(', ') : '< mês'

  return age
}

